/**
 * @generated SignedSource<<31b195746e8d307db215e669ac3a1e48>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NoteEditInfo_page$data = {
  readonly updatedAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  } | null;
  readonly updatedByActor: {
    readonly " $fragmentSpreads": FragmentRefs<"SignedActor_actor">;
  } | null;
  readonly " $fragmentType": "NoteEditInfo_page";
};
export type NoteEditInfo_page$key = {
  readonly " $data"?: NoteEditInfo_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteEditInfo_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteEditInfo_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UnzonedDate",
      "kind": "LinkedField",
      "name": "updatedAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "updatedByActor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SignedActor_actor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetNotePage",
  "abstractKey": null
};

(node as any).hash = "e2803614c1534bc84aa01042724bf53f";

export default node;
